import React from 'react';
import PropTypes from 'prop-types';
import './Loader.css';

const Loader = ({ size, text, fullScreen }) => {
  const sizeClass = size ? `loader-${size}` : '';
  
  if (fullScreen) {
    return (
      <div className="loader-fullscreen">
        <div className={`loader ${sizeClass}`}>
          <div className="loader-spinner"></div>
          {text && <div className="loader-text">{text}</div>}
        </div>
      </div>
    );
  }
  
  return (
    <div className={`loader ${sizeClass}`}>
      <div className="loader-spinner"></div>
      {text && <div className="loader-text">{text}</div>}
    </div>
  );
};

Loader.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  text: PropTypes.string,
  fullScreen: PropTypes.bool
};

Loader.defaultProps = {
  size: 'medium',
  text: '',
  fullScreen: false
};

export default Loader;